import { render, staticRenderFns } from "./ExpovinaButton.vue?vue&type=template&id=715b94f3"
import script from "./ExpovinaButton.vue?vue&type=script&lang=ts"
export * from "./ExpovinaButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports